import type { ReactNode } from 'react';
import React, { useState } from 'react';

import type {
  AIProviderEnum,
  AnalysisIdOrLatest,
  BrandId,
} from '../api/generated/insights.schemas';
import { BrandAnalysisDataProvider } from './BrandAnalysisDataContext';
import { BrandAnalysisMutationsProvider } from './BrandAnalysisMutationsContext';
import type { HostAppProps } from './types';

interface BrandAnalysisProviderProps {
  children: ReactNode;
  hostAppProps?: HostAppProps;
}

export const BrandAnalysisProvider: React.FC<BrandAnalysisProviderProps> = ({
  children,
  hostAppProps = {},
}) => {
  const [brandId, setBrandId] = useState<BrandId | undefined>(undefined);
  const [analysisId, setAnalysisId] = useState<AnalysisIdOrLatest>('latest');
  const [aiProvider, setAiProvider] = useState<AIProviderEnum | undefined>(undefined);

  return (
    <BrandAnalysisMutationsProvider
      brandId={brandId}
      setBrandId={setBrandId}
      analysisId={analysisId}
      setAnalysisId={setAnalysisId}
      aiProvider={aiProvider}
      setAiProvider={setAiProvider}
    >
      <BrandAnalysisDataProvider
        brandId={brandId}
        analysisId={analysisId}
        aiProvider={aiProvider}
        hostAppProps={hostAppProps}
      >
        {children}
      </BrandAnalysisDataProvider>
    </BrandAnalysisMutationsProvider>
  );
};
